// =============================================================================
// CATALYST GALLERY MANIFEST
// =============================================================================
//
// HOW TO ADD A NEW ITEM:
//   1. Drop the file (image or video) into:  public/catalyst/
//   2. Add a new object to the `catalystItems` array below.
//      - file:    the exact filename (case-sensitive, spaces are fine)
//      - caption: a short label shown under the item
//      - poster:  (optional) a filename in public/catalyst/ to use as the
//                 video preview image. Recommended for large videos.
//   3. Type (image vs video) is auto-detected from the file extension.
//   4. Run `npm run build` and redeploy.
//
// SUPPORTED EXTENSIONS:
//   Images: .jpg, .jpeg, .png, .webp, .gif
//   Videos: .mp4, .webm, .mov
//
// TIP: Order in the array = order on the page. First items appear at the top.
// =============================================================================

export const catalystItems = [
  {
    file: "Catalyst - Video.mp4",
    caption: "Promotional Edit",
    poster: "Catalyst - Front View.jpg",
  },
  {
    file: "Catalyst - Front View.jpg",
    caption: "Front Elevation",
  },
  {
    file: "Catalyst - Birds Eye View.jpg",
    caption: "Bird's Eye View",
  },
];

const IMAGE_EXTS = ["jpg", "jpeg", "png", "webp", "gif"];
const VIDEO_EXTS = ["mp4", "webm", "mov"];

export const getMediaType = (filename) => {
  const ext = filename.split(".").pop().toLowerCase();
  if (IMAGE_EXTS.includes(ext)) return "image";
  if (VIDEO_EXTS.includes(ext)) return "video";
  return "unknown";
};

export const getMediaUrl = (filename) =>
  `/catalyst/${encodeURIComponent(filename)}`;
